import type { AuthState, PortalCredentials } from "./authSlice";

const storageKey = "gbo-auth";

export const portalCredentialStorage = {
  read(): AuthState {
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      try {
        const value = JSON.parse(saved) as AuthState;
        if (
          typeof value.credentials?.accessToken === "string" &&
          Number.isFinite(Date.parse(value.credentials.accessExpiresAt)) &&
          Number.isFinite(Date.parse(value.credentials.refreshExpiresAt))
        )
          return value;
      } catch {
        /* Invalid saved credentials require signing in again. */
      }
      this.clear();
    }
    return { credentials: null };
  },
  save(credentials: PortalCredentials) {
    const { accessToken, accessExpiresAt, refreshExpiresAt } = credentials;
    localStorage.setItem(
      storageKey,
      JSON.stringify({ credentials: { accessToken, accessExpiresAt, refreshExpiresAt } }),
    );
  },
  clear() {
    localStorage.removeItem(storageKey);
  },
};
